import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/create',
    method: 'post',
    data: data
  })
}

export function generateCode(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/generate-code',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/update',
    method: 'put',
    data: data
  })
}

export function getMasterMaterialDetail() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-detail/common-list',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/master_material_detail.js